// The drawer's Money block (GRO-247), laid out like Owners: one line per figure, label then value,
// with a "Pipeline" tag on the figure the Pipeline column uses. Which lines show is `moneyLines`.

import type { Opportunity } from '../api/types.ts';
import { hasAmount } from '../board/format.ts';
import { moneyLines } from '../board/money.ts';
import { Dollars } from './PipelineTable.tsx';

export function MoneySection({ opportunity }: { opportunity: Opportunity }) {
  return (
    <section>
      <h3>Money</h3>
      <dl className="owner-list">
        {moneyLines(opportunity).map(line => (
          <div key={line.key} className="owner-line money-line">
            <dt>{line.label}</dt>
            <dd>
              {hasAmount(line.value) ? <Dollars amount={line.value} /> : <span className="muted">—</span>}
              {line.isPipeline ? <span className="owner-tag owner-tag-rep" title="The figure the Pipeline column shows">Pipeline</span> : null}
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
